export default {
  showJoin: (state) => {
    return !state.userIsGroupMember && !state.group.closed
  },

  showRequestToJoin: (state) => {
    return !state.userIsGroupMember && state.group.closed
  }
}
